import {yupResolver} from '@hookform/resolvers/yup';
import {useRouter} from 'next/router';
import React from 'react';
import {
    useForm,
    Controller,
    SubmitHandler
} from 'react-hook-form';
import send from '@/api/send';
import VariantsEnum from '@/enums/VariantsEnum';
import {useGlobalState} from '@/store/index';
import {saveMessage} from '@/store/message/actions';
import Button from '@/UI/form-control/button';
import Form from '@/UI/form-control/form';
import Input from '@/UI/form-control/input';
import Textarea from '@/UI/form-control/textarea';
import Loader from '@/UI/loader';
import validation from './contact.validation';
import styles from './contact.module.css';

interface IValues {
    [key: string]: string
}

const ContactForm: React.FC = () => {
    const router = useRouter();
    const [, dispatch] = useGlobalState();
    const schema = validation();
    const {
        control,
        formState: {
            isSubmitting,
            errors,
        },
        handleSubmit,
    } = useForm<IValues>({
        resolver: yupResolver(schema),
        mode: 'onTouched',
    });
    const onSubmit: SubmitHandler<IValues> = async values => {
        if (values.med) {
            return;
        }

        const response = await send(values);

        if (response.message) {
            dispatch(saveMessage({
                message: {
                    variant: response.variant,
                    content: response.message,
                },
            }));
        }

        router.push('/');
    };

    return (
        <>
            {isSubmitting && <Loader data-test="component-loader" />}
            <Form className={styles.form} data-test="component-contact" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({field}) => (
                        <Input
                            {...field}
                            required
                            label="Jméno"
                            disabled={isSubmitting}
                            maxlength={30}
                            error={errors.name?.message}
                        />
                    )}
                />
                <Controller
                    name="email"
                    control={control}
                    render={({field}) => (
                        <Input
                            {...field}
                            required
                            label="E-mail"
                            type="email"
                            disabled={isSubmitting}
                            maxlength={90}
                            error={errors.email?.message}
                        />
                    )}
                />
                <Controller
                    name="message"
                    control={control}
                    render={({field}) => (
                        <Textarea
                            {...field}
                            required
                            name="message"
                            label="Zpráva"
                            disabled={isSubmitting}
                            maxlength={255}
                            error={errors.message?.message}
                        />
                    )}
                />
                <Controller
                    name="med"
                    control={control}
                    render={({field}) => (
                        <input
                            {...field}
                            type="text"
                            name="med"
                            autoComplete="off"
                            tabIndex={-1}
                            className={styles.hidden}
                        />
                    )}
                />
                <Button
                    type="submit"
                    variant={VariantsEnum.info}
                    className={styles.submit}
                    disabled={isSubmitting}
                >
                    Odeslat
                </Button>
            </Form>
        </>
    );
};

export default ContactForm;
